(function ($) {
  $(function () {
    var $detailPageContent = $('.detail-page-content');

    if (!$detailPageContent.length) return;

    var detailPageContent = (function () {
      var $dropDownHead = $detailPageContent.find('.types-dropdown .dropdown');
      var $dropDownAnchor = $detailPageContent.find('.types-dropdown ul li a');
      var isOpen = false; // Flag to track dropdown state

      function dropDownHandler(e) {
        e.preventDefault();
        isOpen = !isOpen; // Toggle open/closed state

        $(this).toggleClass('dropdown--open', isOpen);
        $(this).find('.dropdown__menu').slideToggle(300);
      }

      function dropDownAnchorHandler(e) {
        location.href = e.target.href;
        var optionText = $(this).text();
        changeDropdownHeadText(optionText);
        return false;
      }

      function changeDropdownHeadText(textString) {
        $detailPageContent.find('.dropdown__head p strong').text(textString);
      }

      function closeDropDown(event) {
        if (isOpen && !$(event.target).closest('.types-dropdown').length ) {
          $dropDownHead.removeClass('dropdown--open');
          $dropDownHead.find('.dropdown__menu').slideUp(300);
          isOpen = false;
        }
      }

      return {
        init: function () {
          this.bindEvents();
        },
        bindEvents: function () {
          $dropDownHead.on('click', dropDownHandler);
          $dropDownAnchor.on('click', dropDownAnchorHandler);
          $(document).on('click', closeDropDown); // Listen for clicks outside
        },
      }
    })();

    detailPageContent.init();
  });
})(jQuery);